// ============================================================
// Panel genelinde ortak bildirim (toast) yardimcisi.
//
// Her sayfada ayri ayri toastr ayari kopyalanmasin diye tek yerde
// toplandi. Kullanim:  toastSuccess("Kayit silindi.")
// ============================================================
import toastr from "toastr";
import "toastr/build/toastr.min.css";

toastr.options = {
  positionClass: "toast-top-right",
  timeOut: 4000,
  extendedTimeOut: 1000,
  closeButton: true,
  progressBar: true,
  preventDuplicates: true,
  newestOnTop: true,
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
  showDuration: 300,
  hideDuration: 1000,
};

export const toastSuccess = (message, title = "Başarılı") =>
  toastr.success(message, title);

export const toastError = (message, title = "Hata") =>
  toastr.error(message, title);

export const toastInfo = (message, title = "") => toastr.info(message, title);

export const toastWarning = (message, title = "Uyarı") =>
  toastr.warning(message, title);

export const clearToasts = () => toastr.clear();

export default toastr;
